import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';

export const PriorityTileContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: ${({ theme }) => theme.colors.grey_1};
  background: ${({ theme }) => theme.colors.beige_2};
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};

  ${media.md`
    flex-direction: column;
    align-items: flex-start;
  `}

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
    color: ${({ theme }) => theme.colors.grey_1};
    background: ${({ theme }) => theme.colors.purple_5};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-wrap: break-word;

  ${media.tablet`
    width: 100%;
  `}
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;

  ${media.tablet`
    width: 100%;
  `}
`;

export const TileContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 56px;

  ${media.md`
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  `}
`;
